import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { environment } from '@environments/environment';

@Injectable({ providedIn: 'root' })
export class VendorRequestService {

    private selectedPlanSubject = new BehaviorSubject<{ planId?: string, services?: string[] }>({});
    currentSelectedPlan$ = this.selectedPlanSubject.asObservable();

    constructor(private http: HttpClient) { }

    createRequest(vendorData) {
        return this.http.post<any[]>(`${environment.apiUrl}/vendor-request/create`, vendorData);
    }

    getRequest(_id) {
        return this.http.get<any>(`${environment.apiUrl}/vendor-request/${_id}`);
    }

    // Get vendor request for current logged-in user (for draft recovery)
    getMyRequest() {
        return this.http.get<any>(`${environment.apiUrl}/vendor-request/my-request`);
    }

    // Get vendor request draft by ID (for draft recovery without authentication)
    getDraftById(_id: string) {
        return this.http.get<any>(`${environment.apiUrl}/vendor-request/draft/${_id}`);
    }

    updateRequest(data) {
        return this.http.post<any>(`${environment.apiUrl}/vendor-request/update`, data);
    }

    // Select a plan for vendor request (Step 2)
    selectPlan(data: { _id: string, planId: string, billingType?: string }) {
        return this.http.post<any>(`${environment.apiUrl}/vendor-request/select-plan`, data);
    }

    // Apply a free plan directly (skip checkout)
    applyFreePlan(data: { _id: string, planId: string }): Observable<any> {
        return this.http.post<any>(`${environment.apiUrl}/vendor-request/apply-free-plan`, data);
    }

    setSelectedPlan(data: {planId: string, services: string[]}) {
        this.selectedPlanSubject.next(data);
    }

    checkIfUserIsVendor(): Observable<any> {
        return this.http.get<any>(`${environment.apiUrl}/vendor-request/check-vendor-status`);
    }

    // Update rejected fields (when vendor corrects them)
    updateRejectedFields(_id: string, updates: any): Observable<any> {
        // Check if any updates contain files
        const hasFiles = Object.values(updates).some(value => value instanceof File);
        
        if (hasFiles) {
            // Use FormData for file uploads
            const formData = new FormData();
            formData.append('_id', _id);
            
            for (const [key, value] of Object.entries(updates)) {
                if (value instanceof File) {
                    formData.append(key, value, value.name);
                } else if (value !== null && value !== undefined) {
                    formData.append(key, String(value));
                }
            }
            
            return this.http.post<any>(`${environment.apiUrl}/vendor-request/update-rejected-fields`, formData);
        } else {
            return this.http.post<any>(`${environment.apiUrl}/vendor-request/update-rejected-fields`, { _id, updates });
        }
    }

    // Get admin URL for subscription management
    getAdminUrl(): Observable<any> {
        return this.http.get<any>(`${environment.apiUrl}/vendor-request/get-admin-url`);
    }
}